import { put, call, take, fork } from 'redux-saga/effects'
import { collectionTranslateService } from '../../api/course-collection'
import { collectionTranslateSuccess } from '../../reducers/course-collection/action'
import { COLLECTION_TRANSLATE } from '../../reducers/course-collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* collectionTranslateFlow(payload) {
  try {
    const { id, targetLanguage, callback } = payload

    const response = yield call(collectionTranslateService, id, targetLanguage)

    yield put(collectionTranslateSuccess(response.data))
    yield put(operationSuccess())

    if (callback) {
      callback(response.data)
    }
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* collectionTranslateWatcher() {
  while (true) {
    const action = yield take(COLLECTION_TRANSLATE)
    const { payload } = action

    yield fork(generalSaga, collectionTranslateFlow, payload)
  }
}
